import {
  ADD_CONVERSATION,
  FETCH_CONVERSATIONS,
  CONVERSATIONS_FETCHED,
  NAV_TO_CONVERSATION,
  NAV_TO_CONVERSATION1,
  NAV_TO_ORDER_CONV,
  TOGGLE_PINNED,
  CONVERSATION_UPDATED,
  PINNED_CHANGE,
  HOIST_CONV,
  MARK_READ,
  MARK_READ_SUCCESS,
  REMOVE_CONVERSATION,
  QUERY_CONV_STATS,
  CONV_STATS_FETCHED,
  RESET_CONVS
} from './actionTypes'

export const addConversation = data => ({ type: ADD_CONVERSATION, payload: data })
export const fetchConvs = payload => ({ type: FETCH_CONVERSATIONS, payload })
export const convsFetched = (data, type) => ({ type: CONVERSATIONS_FETCHED, payload: { data, type } })
export const navToConversation = (id, orderId) => ({ type: NAV_TO_CONVERSATION, payload: { id, orderId } })
export const navToOrderConv = orderId => ({ type: NAV_TO_ORDER_CONV, payload: { orderId } })
export const togglePinned = id => ({ type: TOGGLE_PINNED, payload: { id } })
export const convUpdated = data => ({ type: CONVERSATION_UPDATED, payload: data })
export const pinnedChange = (id, is_pinned) => ({ type: PINNED_CHANGE, payload: { id, is_pinned } })
export const hoistConv = id => ({ type: HOIST_CONV, payload: { id } })
export const markRead = id => ({ type: MARK_READ, payload: { id } })
export const markReadSuccess = id => ({ type: MARK_READ_SUCCESS, payload: { id } })
export const removeConv = id => ({ type: REMOVE_CONVERSATION, payload: { id } })
export const queryConvStats = type => ({ type: QUERY_CONV_STATS, payload: { type } })
export const convStatsFetched = (type, total) => ({ type: CONV_STATS_FETCHED, payload: { type, total } })
export const resetConvs = () => ({ type: RESET_CONVS, payload: {} })



